import { render, staticRenderFns } from "./ed-portal-grades.component.vue?vue&type=template&id=7783b9b6&scoped=true&"
import script from "./ed-portal-grades.component.ts?vue&type=script&lang=ts&"
export * from "./ed-portal-grades.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-portal-grades.component.scss?vue&type=style&index=0&id=7783b9b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7783b9b6",
  null
  
)

export default component.exports